<!-- Start Our Works Area -->
<section id="works" class="our-works ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2 text-center">
                <div class="section-title">
                    <h2>Seylan Web Banners & Panels</h2>
                    <p> Seylan Bank sought to create top-of-mind-awareness among its various target groups, we were
                        successful in designing their pennants, banners, web banners, wall designs and lamp-post posters
                        for their offerings such as Gold Loans, Tikiri, SME and My Plan..
                    </p>
                    <!-- <p>
                        When working together with Seylan bank, Designs Dee had to consider many vital factors so as to
                        provide exactly what the bank’s management wanted. The colors, fonts, and other creative
                        parameters were selected adhering to the bank’s default theme. As a result, we were able to
                        protect and strengthen the bank's brand image further as demanded by the bank. We also made
                        every effort to provide the finest possible client-oriented service targeting the bank's various
                        business components, just as we did in the creative design process.
                    </p> -->
                    <span class="section-title-bg">WebBanners</span>
                </div>
            </div>
        </div>

        <div id="Portfolio" class="row">
            <div class="col-sm-6 col-lg-4 filtr-item web" *ngFor="let image of album; let i=index">

                <div class="work-details" (click)="open(i)" *ngIf="image.type == 'image'">
                    <img [src]="image.thumb" [alt]="image.caption">
                </div>

                <div class="work-details popup-youtube" [attr.href]="image.link" *ngIf="!(image.type == 'image')">
                    <img [src]="image.thumb" [alt]="image.caption">
                </div>

            </div>
        </div>

    </div>
</section>
<!-- End Our Works Area -->